import { render, staticRenderFns } from "./xsorderPoolSpdList.vue?vue&type=template&id=ce3afd58&scoped=true"
import script from "./xsorderPoolSpdList.vue?vue&type=script&lang=js"
export * from "./xsorderPoolSpdList.vue?vue&type=script&lang=js"
import style0 from "./xsorderPoolSpdList.vue?vue&type=style&index=0&id=ce3afd58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3afd58",
  null
  
)

export default component.exports